import React from "react";

const getHighlightedText = (text, highlights) => {
  const lowerCaseHighlights = highlights.map((word) => word.toLowerCase());
  const regex = new RegExp(`(${lowerCaseHighlights.join("|")})`, "gi");
  const parts = text.split(regex);

  if (highlights.length == 0) {
    const splitText = text.split(" ");
    const takeoutText = splitText.slice(0, -2).join(" ");
    const restaurantText = splitText.slice(-2);
    return (
      <span>
        {takeoutText + " "}
        <span className="restuarant-text">
          <span>{restaurantText[0]}</span> {restaurantText[1]}
        </span>
      </span>
    );
  } else {
    return parts.map((part, index) => {
      if (lowerCaseHighlights.includes(part.toLowerCase())) {
        // Highlighted text
        return (
          <span key={index} className="highlight">
            <span>from</span> {part}
          </span>
        );
      } else {
        // Normal text
        return <span key={index}>{part}</span>;
      }
    });
  }
};

const WelcomeBonus = ({
  title,
  value,
  description,
  displayState,
  redeemableDaysAndHours,
  redeemableHoursShort,
  redeemableDaysShort,
  offerName,
  minimumSpendAmount,
}) => {
  const isEmailClaimSuccess = displayState === 14;
  return (
    <div className="welcome-bonus-container">
      <div className="welcome-bonus-top">
        <div className="shoulder-hours-text">{offerName ? offerName : ""}</div>
        <div className="offer-claim-header-section">
          <div className="offer-claim-header">
            {displayState !== 7 && !isEmailClaimSuccess
              ? `Claim your ${value}`
              : `Go spend your ${value}`}
          </div>
          {minimumSpendAmount !== 0 && (
            <div className="offer-header-subtext">
              {`Off your next $${minimumSpendAmount}+ meal`}
              {redeemableDaysShort && !redeemableHoursShort && (
                <span>
                  {" from "}
                  <span className="shoulder-hours-text">
                    {redeemableDaysShort}
                  </span>
                </span>
              )}
            </div>
          )}
        </div>
      </div>

      {redeemableDaysAndHours && redeemableHoursShort && (
        <div className="shoulder-hours-text">{redeemableDaysAndHours}</div>
      )}
      <div className="divider-new"></div>
      {!!description.trim() && (
        <>
          <div className="offer-details">
            {description.split("\n").map((str, i) => (
              <p key={i}>{str}</p>
            ))}
          </div>
          <div className="divider-new"></div>
        </>
      )}
    </div>
  );
};

export default WelcomeBonus;
